const TermsAndConditions = () => {
  return (
    <div className="container mx-auto px-4 py-10 max-w-3xl">
      <h1 className="text-3xl font-bold mb-6">Terms and Conditions</h1>

      <p className="mb-4">
        By accessing and using Luxor Clothing, you agree to comply with these
        terms and conditions.
      </p>

      <p className="mb-4">
        All products listed are subject to availability. We reserve the right to
        modify or discontinue any product without prior notice.
      </p>

      <p className="mb-4">
        Prices and offers are subject to change. Luxor Clothing reserves the
        right to cancel any order in case of pricing or stock errors.
      </p>
    </div>
  );
};

export default TermsAndConditions;